import React, { useEffect } from "react";
import { useDispatch } from 'react-redux';
import { constants } from '../constants'
import axios from "axios";

import { store } from '../store';

// Set up interceptor on all fetch API calls
// Increments redux spinner state when api is called
// Decrements redux spinner state again when it is returned
(function () {
  const originalFetch = window.fetch;
  window.fetch = function () {
    store.dispatch({ type: constants.REQUEST, value: true })
    return originalFetch.apply(this, arguments)
      .then((res) => {
        store.dispatch({ type: constants.REQUEST, value: false })
        return res;
      })
  }
})();


const Interceptor = () => {

  const dispatch = useDispatch();

  const addAuthInterceptor = () => {
    axios.interceptors.request.use(
      config => {
        dispatch({ type: constants.REQUEST, value: true });
        return config;
      },
      error => {
        return Promise.reject(error);
      }
    );
  };

  const addErrorInterceptor = () => {
    axios.interceptors.response.use(
      response => {
        dispatch({ type: constants.REQUEST, value: false });
        return response;
      },
      error => {
        if (error.response) {
          const code = error.response.status;
          dispatch({ type: constants.REQUEST, value: false });
          return error;
          // if (code === 401) {

          // } else {
          //   // let message = "Something went wrong.";
          //   // if (code === 403) {
          //   //   message = "You’re not authorized to do that.";
          //   // } else if (error.message) {
          //   //   message = error.message;
          //   // }
          // }
        }
        return Promise.reject(error);
      }
    );
  };

  useEffect(addAuthInterceptor, []);
  useEffect(addErrorInterceptor, []);

  return <React.Fragment />;
}

export default Interceptor;
